export enum FeatureName {
  PRODUCT_MIGRATION = 'product_migration'
}
